import { createContext } from 'react';

import { IMatomoType } from './types';

export const MatomoContextDefault: IMatomoType = { mtm: undefined, tracker: undefined, window: undefined };

export const MatomoContext = createContext(MatomoContextDefault);
